import type * as React from 'react'

import { type IBaseButtonProps } from './BaseButton'
import { DangerButtonStyled } from './styles/DangerButtonStyled'

export const DangerButton: React.FC<IBaseButtonProps> = DangerButtonStyled

DangerButton.displayName = 'DangerButton'
